import script from "./SettingsUser.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsUser.vue?vue&type=script&setup=true&lang=js"

import "./SettingsUser.vue?vue&type=style&index=0&id=54f3d89e&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54f3d89e"]])

export default __exports__